import React, { useState } from 'react';
import inspectionService from '../../services/inspectionService';
import { useSpinner } from '../../context/SpinnerContext';
import Notification from '../Notification';
import './InspectionReport.css';
import logger from '../../utils/logger';

const InspectionReport = ({ inspectionId, inspectionStatus }) => {
    const [reportGeneratedAt, setReportGeneratedAt] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [notification, setNotification] = useState({ visible: false, message: '', type: 'info' });
    const { showSpinner, hideSpinner } = useSpinner();

    const formatDate = (dateString) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('es-ES', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (error) {
            return dateString;
        }
    };

    const showNotification = (message, type = 'info') => {
        setNotification({ visible: true, message, type });
        setTimeout(() => {
            setNotification({ visible: false, message: '', type: 'info' });
        }, 5000);
    };

    const handleDownloadReport = async () => {
        try {
            setIsLoading(true);
            showSpinner('Generando informe...');
            logger.info('Generando informe...', {
                inspectionId: inspectionId,
            }, 'InspectionReport');
            const response = await inspectionService.generateInspectionReport(inspectionId);

            if (response.downloadUrl) {
                // Guardar fecha de generación si es la primera vez
                if (response.reportGeneratedAt && !reportGeneratedAt) {
                    setReportGeneratedAt(response.reportGeneratedAt);
                }

                // Descargar el PDF
                const link = document.createElement('a');
                link.href = response.downloadUrl;
                link.download = `informe-inspeccion-${inspectionId}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                showNotification('Informe descargado exitosamente', 'success');
            } else {
                throw new Error('No se pudo obtener la URL de descarga');
            }
        } catch (error) {
            logger.error('Error generando informe:', error, null, 'InspectionReport');
            showNotification('Error al generar el informe. Por favor intenta nuevamente.', 'error');
        } finally {
            setIsLoading(false);
            hideSpinner();
        }
    };

    return (
        <div className="inspection-report-section">
            <div className="report-header">
                <h3 className="report-title">Informe de Inspección</h3>
                {reportGeneratedAt && (
                    <p className="report-date">
                        Generado el: {formatDate(reportGeneratedAt)}
                    </p>
                )}
            </div>
            <button
                onClick={handleDownloadReport}
                disabled={isLoading}
                className="download-report-button"
            >
                {isLoading ? 'Generando...' : 'Descargar Informe PDF'}
            </button>
            
            {/* Notification Component */}
            <Notification
                visible={notification.visible}
                message={notification.message}
                type={notification.type}
                onClose={() => setNotification({ visible: false, message: '', type: 'info' })}
            />
        </div>
    );
};

export default InspectionReport;